import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class TypevoyageService {

  constructor(private http: HttpClient) { }

  savetypevoyage(type: any): any {
    return this.http.post(`${API_URL}/typevoyage`, type, {
      observe: 'response',
    });
  }

  getAllTypeVoyage(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/typevoyage?page=${page}&size=${size}`);
  }

  deleteTypevoayge(id: any): any {
    return this.http.delete(`${API_URL}/typevoyage/${id}`);
  }

  getTypeVoyagelist(): any {
    return this.http.get(`${API_URL}/typevoyagelist`);
  }
}
